'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./collect-info-modal.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _collectInfoForm = require('./collect-info-form');

var _collectInfoForm2 = _interopRequireDefault(_collectInfoForm);

var _fixedModal = require('common/components/fixed-modal');

var _fixedModal2 = _interopRequireDefault(_fixedModal);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollectInfoModal = function (_Component) {
    _inherits(CollectInfoModal, _Component);

    function CollectInfoModal() {
        _classCallCheck(this, CollectInfoModal);

        return _possibleConstructorReturn(this, (CollectInfoModal.__proto__ || Object.getPrototypeOf(CollectInfoModal)).apply(this, arguments));
    }

    _createClass(CollectInfoModal, [{
        key: 'render',
        value: function render() {

            var subheader = _react2['default'].createElement(
                'div',
                { className: 'subheader' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'Please take a few minutes to build your profile. This information will help us personalize your experience and better define future product updates.'
                )
            );

            var _props$collectInfoFor = this.props.collectInfoForm,
                fields = _props$collectInfoFor.fields,
                values = _props$collectInfoFor.values,
                namespace = _props$collectInfoFor.namespace;

            var form = _react2['default'].createElement(_collectInfoForm2['default'], {
                fields: fields,
                values: values,
                action: _hfReactHelper2['default'].urlHelper('home/collectInfo', _hfReactHelper2['default'].HfSites.SITE_CODE_HS),
                onSuccess: this.props.onSuccess,
                namespace: namespace,
                isEnterprise: this.props.isEnterprise
            });

            return _react2['default'].createElement(
                _fixedModal2['default'],
                { width: 610, hideOnOverlayClick: true },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-collect-info-modal' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-collect-info-modal--header' },
                        _react2['default'].createElement(
                            'h1',
                            null,
                            'Build your e-signature profile'
                        ),
                        subheader
                    ),
                    form
                )
            );
        }
    }]);

    return CollectInfoModal;
}(_react.Component);

exports['default'] = CollectInfoModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/collect-info/collect-info-modal.jsx
 ** module id = 1187
 ** module chunks = 0 1
 **/